// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__24JgQ","error":"InputSecondary_error__hpti1","disabled":"InputSecondary_disabled__14_uB"};